import { ActionTypes, ReduxAction } from './types';

import { Dispatch } from 'redux';
import { SpracheService } from '../../api';

export const getSprachen = () => async (dispatch: Dispatch<ReduxAction>) => {
  new SpracheService().getAllSprachen().then(result => {
    dispatch({
      type: ActionTypes.GET_SPRACHEN,
      payload: result.data,
    });
  });
};
